<template>
    <div class="feedback-gift">
        <body-feedback
            :index="index"
            :beforeBold="$t('views.feedback.gift.beforeBold')"
            :titleBold="$t('views.feedback.gift.titleBold')"
            :afterBold="$t('views.feedback.gift.afterBold')"
            actionName="sendGift">
            <div>
                <option-select 
                    :options="options"
                    typeOption="radio"
                    itemName="gift"
                    :indexTrue="1"
                    :pageIndex="4"></option-select>
                    <form-default
                        v-if="formShow"
                        :title="$t('views.feedback.gift.form_default.title')"
                        :labels="labels"></form-default>
            </div>
        </body-feedback>
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import OptionSelect from '../../components/shared/default/OptionSelect.vue'
import FormDefault from '../../components/shared/default/FormDefault'
import Loader from "../../components/shared/default/Loader"
import { Bus } from '../../event-bus.js'
export default {
    components: {
        BodyFeedback,
        OptionSelect,
        FormDefault,
        Loader
    },
    data(){
        return{
            options : [
                {
                    value : 0,
                    text: this.$t("views.feedback.gift.options[0]")
                },
                {
                    value : 1,
                    text: this.$t("views.feedback.gift.options[1]")
                }
            ],
            labels : [
                {
                    name : 'nome',
                    type : 'text',
                    placeholder: this.$t("views.feedback.gift.labels[0]")
                },
                {
                    name : 'company',
                    type : 'text',
                    placeholder: this.$t("views.feedback.gift.labels[1]")
                },
                {
                    name : 'email',
                    type : 'email',
                    placeholder: this.$t("views.feedback.gift.labels[2]")
                },
                {
                    name : 'telefone',
                    type : 'text',
                    placeholder: this.$t("views.feedback.gift.labels[3]")
                }
            ],
            formShow : false,
            gift : '',
            isLoading: false
        }
    },
    props: ["index"],
    created(){
        Bus.$on('showForm', this.showForm)
        Bus.$on('hideForm', this.hideForm)
        Bus.$on('sendGift', this.sendGift)
        Bus.$on('defineGift', this.defineGift)
    },
    destroyed(){
        Bus.$off('showForm')
        Bus.$off('hideForm')
        Bus.$off('sendGift')
        Bus.$off('defineGift')
    },
    methods: {
        showForm(){
            this.formShow = true
            Bus.$emit('disabledButton')
        },
        hideForm(){
            this.formShow = false
        },
        async sendGift(){
            // Bus.$emit('nextStep')
            if(this.gift == 1){
                await this.$store.dispatch('callSetFeedback', {
                    itemName : 'gift',
                    itemData : {
                        name : nome.value,
                        companyName : company.value,
                        email : email.value,
                        telephone : telefone.value
                    }
                })
            }
            await this.sendFeedback()

            this.$router.push('/feedback-finish')
        },
        async sendFeedback(){
            this.isLoading = false
            const feedback = this.$store.getters.getFeedback
            const userId = localStorage.getItem('uid')
            const workspaceId = localStorage.getItem('workspaceId')
            feedback.userId = userId
            feedback.workspaceId = workspaceId
            feedback.acceptContact = Boolean(localStorage.getItem("acceptContact")) || false
            // delete feedback.gift
            // return console.log("feedback: ", feedback)
            this.isLoading = false
            try {
                const response = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/feedbacks`, feedback)
                // console.log("Feedback created: ", response.data)
                if(response.body.fields) localStorage.setItem('feedbackId', response.body.fields.id)
                localStorage.setItem('feedback', true)
                if(feedback.acceptContact) {
                    const hubspotRes = await this.$http.post(`${process.env.VUE_APP_URL_INTEGRATION_SYSTEM}/hubspot/contact`, {userId})
                    // console.log("hubspot contact created: ", hubspotRes.data)
                }
                
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.error("error trying to send feedback: ", error.response)
                this.isLoading = false
            }            
            this.isLoading = false
        },
        defineGift(gift){
            this.gift = gift
        }
    }
}
</script>
<style lang="scss" scoped>
    .feedback-gift{
        width: 100%;
        height: 100%;
    }
</style>
